import { render, staticRenderFns } from "./slm.vue?vue&type=template&id=60554496"
import script from "./slm.vue?vue&type=script&lang=js"
export * from "./slm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports